function get_scrollTop() {
    if ($("html").scrollTop()) return $("html").scrollTop();
    if ($("body").scrollTop()) return $("body").scrollTop();
    return 0;
}

function rendered() {

}

function startRender() {
    requestAnimationFrame(rendered);
}

function loaded() {
    requestAnimationFrame(startRender);
}

function isMobile() {
    return window.matchMedia('(max-width: 1049px)').matches;
}

function isDesktop() {
    return window.matchMedia('(min-width: 1050px)').matches;
}

function exist(el) {
    return el.length > 0;
}

function createProductSaleFlag(products) {
    products.each(function () {
        const prices = $(this).find('.prices')
        const sale = prices.find('.price-save')
        let flags = $(this).find('.flags')
        if (sale.length > 0) {
            if (flags.length === 0) {
                const flagsWrapper = $('<div class="flags flags-default">')
                $(this).find('.image').prepend(flagsWrapper)
                flags = $(this).find('.flags')
            }
            if (flags.find('.flag.flag-sale').length === 0) {
                flags.prepend(flagSale(sale.text().replace(/[()]/g, '')))
            }

            prices.addClass('has-sale')
        }
    });
}

function flagSale(sale) {
    return `<span class="flag flag-sale">${sale}</span>`;
}

function _t(key) {
    const lang = $('html').attr('lang')
    const translation = translations[lang] && translations[lang][key];

    if (translation !== undefined) {
        return translation;
    } else {
        return key;
    }
}

function isExist(element) {
    return element && element.length > 0;
}

function fixedPosition(element, elementToFix) {
    if (isExist(element) && isExist(elementToFix)) {
        const topPosition = elementToFix.position().top;
        element.css('margin-top', topPosition);
    }
}

function getPriceFromText(text) {
    const match = text.match(/\d+/);
    return match ? parseInt(match[0], 10) : null;
}